
import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { SecretValue } from "client/Api/Apps/common";

export interface AutotaskConnectionListItemModel {
	id: number;
	name: string;
	serverUrl: string;
}

export interface AutotaskConnectionModel {
	id: number;
	name: string;
	username: string;
}

export interface AutotaskConnectionSaveModel {
	name: string;
	username: string;
	password: SecretValue;
}

export function list(
	signal?: AbortSignal
): Promise<readonly AutotaskConnectionListItemModel[]> {
	return httpClient.get<readonly AutotaskConnectionListItemModel[]>(
		"UiApi/AutotaskConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<AutotaskConnectionModel> {
	return httpClient.get<AutotaskConnectionModel>(
		`UiApi/AutotaskConfiguration/${id}`,
		undefined,
		{ signal }
	);
}

export function create(
	model: AutotaskConnectionSaveModel,
	signal?: AbortSignal
): Promise<{ id: number; }> {
	return httpClient.post<{ id: number; }>(
		"UiApi/AutotaskConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: AutotaskConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return httpClient.put<void>(
		`UiApi/AutotaskConfiguration/${id}`,
		 model,
		 { signal }
	);
}

export function deleteMultiple(
	ids: readonly number[],
	signal?: AbortSignal
): Promise<void> {
	return httpClient.delete<void>(
		"UiApi/AutotaskConfiguration",
		ids,
		{ signal }
	);
}